import { Component, input } from '@angular/core';

export interface CardDisclosureColumns {
  col1: string;
  col2: string;
}

export interface CardDisclosureModel {
  title: string;
  data: CardDisclosureColumns[];
}

@Component({
  selector: 'app-card-disclosure-table',
  templateUrl: './card-disclosure-table.component.html',
  styleUrl: './card-disclosure-table.component.scss',
})
export class CardDisclosureTableComponent {
  readonly cardDisclosures = input<CardDisclosureModel>();
}
